import React from 'react';
import styles from './Label.css';
import classNames from 'classnames';

export default class Label extends React.PureComponent {
	render() {
		const {
			className,
			control,
			children
		} = this.props;

		return (
			<label className={classNames(styles['label'], className)}>
				<span className={styles['control-container']}>
					{control}
				</span>
				<span className={styles['content-container']}>
					{children}
				</span>
			</label>
		);
	}
}